import { InjectionToken } from '@angular/core'
import { Company } from '@mybitzer/core/company/company.api'
import { Customer } from '@mybitzer/core/customer/customer.api'
import { Observable, Subscription } from 'rxjs'

export interface CustomerInfo {
  id: number
  externalId: string
  name: string
  email: string
  companyId: number

  company: Company
}

export interface CustomerApi {
  getById(id: string): Observable<CustomerInfo>

  setName(id: number, value: string): Observable<Customer>

  getByEmail(email: string): Observable<Customer>

  findByEmail(email: string[]): Observable<Customer[]>

  remove(id: number): Observable<Customer>

  setSubscriptionTypes(customerId: number, types: string[]): Observable<Subscription>
}

export const CUSTOMER_SERVICE = new InjectionToken<CustomerApi>('CustomerService')
